import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Typography,
  IconButton,
  Skeleton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";

const DeviceTypeCard = ({ deviceType, onEdit, onDelete, loading = false }) => {
  return (
    <Card
      sx={{
        boxShadow: 3,
        borderRadius: 2,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {loading ? (
        <Skeleton variant="rectangular" height={140} />
      ) : (
        <CardMedia
          component="img"
          height="140"
          image={deviceType.image_url || "https://placehold.co/150"}
          alt={deviceType.type_name}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://placehold.co/150";
          }}
        />
      )}

      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {loading ? <Skeleton width="80%" /> : deviceType.type_name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {loading ? (
            <Skeleton width="60%" />
          ) : (
            `Manufacture: ${deviceType.manufacture}`
          )}
        </Typography>
      </CardContent>

      <CardActions>
        {loading ? (
          <>
            <Skeleton
              variant="circular"
              width={32}
              height={32}
              sx={{ mr: 1 }}
            />
            <Skeleton variant="circular" width={32} height={32} />
          </>
        ) : (
          <>
            <IconButton
              onClick={() => onEdit(deviceType)}
              sx={{
                color: "#22C55E",
                mr: 1,
                "&:hover": { backgroundColor: "#BBF7D0" },
              }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={() => onDelete(String(deviceType.id))}
              sx={{
                color: "#6B7280",
                "&:hover": { backgroundColor: "#E5E7EB" },
              }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        )}
      </CardActions>
    </Card>
  );
};

DeviceTypeCard.propTypes = {
  deviceType: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image_url: PropTypes.string,
    type_name: PropTypes.string,
    manufacture: PropTypes.string,
  }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  loading: PropTypes.bool,
};

export default DeviceTypeCard;
